.signet-date-picker {
  font-family: Lato;
  font-weight: 400;
  position: relative;
  width: fit-content;

  .input-container {
    position: relative;

    .input-label {
      position: absolute;
      top: -25%;
      left: 10px;
      padding: 3px;
      font-size: 0.75rem;
      background: transparent;
      color: var(--gray-500);
      transition: all 0.25s ease-in-out;
      pointer-events: none;
      z-index: 99;
      font-weight: 400;

      &:before {
        content: '';
        position: absolute;
        height: 6px;
        bottom: 8px;
        z-index: -1;
        width: 110%;
        display: block;
        left: -2px;
        background: var(--pure-white);
      }
    }

    input {
      display: inline-block;
      border: 1px solid #808080;
      background-color: transparent;
      padding: 12px 16px;
      border-radius: 4px;
      outline: 0;

      &.input-size-small {
        padding-top: 5px;
        padding-bottom: 5px;
        padding-left: 12px;
        padding-right: 12px;
        font-size: 14px;
        line-height: 20px;
        /* 32px total height with border */
      }

      &.input-size-medium {
        padding-top: 10px;
        padding-bottom: 10px;
        padding-left: 14px;
        padding-right: 14px;
        font-size: 16px;
        line-height: 20px;
        /* 42px total height with border */
      }

      &.input-size-large {
        padding-top: 15px;
        padding-bottom: 15px;
        padding-left: 16px;
        padding-right: 16px;
        font-size: 18px;
        line-height: 20px;
        /* 52px total height with border */
      }

      &:focus {
        border: 1px solid var(--action-default);
        box-shadow: 0px 0px 3px var(--action-default);
      }

      &.disabled {
        cursor: not-allowed;
        background-color: var(--gray-50) !important;
      }

      &.warning {
        border: 1px solid #ffcc00;
      }

      &.error {
        border: 1px solid #cc3300;
      }
    }
  }

  .input-clear-button {
    position: absolute;
    top: 25%;
    right: 5%;
    cursor: pointer;
    font-weight: bold;
    color: var(--gray-500);
  }
}

signet-date-picker[size='small'] .input-container .input-label,
signet-date-picker[size='sm'] .input-container .input-label {
  top: -36%;
}

.signet-date-picker__calendar-container-wrapper {
  background-color: white;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.3);
  border-radius: 6px;
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 9999;
  display: flex;

  .shortcuts {
    border-right: 1px solid #808080;
    padding: 20px;
    display: flex;
    flex-direction: column;
    align-items: start;

    .shortcut-button {
      white-space: nowrap;
      margin-bottom: 4px;

      font-size: inherit;
      cursor: pointer;
    }
  }

  .calendar-container-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    padding: 20px;

    .year-selector {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 20px;
      padding-bottom: 10px;
      border-bottom: 1px solid #cdcdcd;

      .calendar-icon {
        line-height: 0 !important;
      }
    }

    .year-selector-content {
      display: grid;
      grid-template-columns: repeat(4, minmax(0, 1fr));
      gap: 40px;

      .year-item {
        cursor: pointer;

        &:hover {
          color: var(--primary-main);
        }
      }
    }

    .month-selector {
      display: grid;
      grid-template-columns: repeat(4, minmax(0, 1fr));
      gap: 40px;

      .month-item {
        cursor: pointer;

        &:hover {
          color: var(--primary-main);
        }
      }
    }

    .calendar-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 20px;
      width: 100%;

      .month-year {
        margin-left: 10px;

        .month,
        .year {
          cursor: pointer;

          &:hover {
            color: var(--primary-main);
          }
        }
      }
    }

    .weekdays {
      display: grid;
      grid-template-columns: repeat(7, minmax(0, 1fr));
      gap: 0;

      .weekday {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        width: 36px;
        height: 36px;
        color: #717171;
      }
    }

    .days {
      display: grid;
      grid-template-columns: repeat(7, minmax(0, 1fr));
      gap: 0;

      .day {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 36px;
        width: 36px;
        border-radius: 100%;
        cursor: pointer;
        font-size: 12px;
        margin: 0;
        position: relative;

        &:hover {
          border: 1px solid var(--gray-500);
        }

        &.current-day {
          border: 1px solid var(--gray-500);
          border-radius: 100% !important;
        }

        &.selected-day {
          background-color: var(--action-default);
          color: white;
        }
        &:not(.blank, .current-day):hover {
          border: transparent;
        }

        &:not(.blank):hover:after {
          background: var(--action-default);
          border: transparent;
          border-radius: 50%;
          opacity: 0.2;
          display: block;
          content: '';
          width: 100%;
          height: 100%;
          z-index: -2;
          position: absolute;
          top: 0;
          left: 0;
        }

        &.disabled-day {
          background-color: rgba(0, 0, 0, 0.1);
          color: white;
          cursor: not-allowed;
        }

        &.blank {
          cursor: default;
          background-color: transparent;

          &:hover {
            border: none;
          }
        }
      }
    }

    .calendar-icon {
      cursor: pointer !important;
    }
  }
}
